module.exports = __webpack_public_path__ + "img/uped_img.be266022.png";